//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { arrangementOfIcons } from '~/utils/utils';
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    itsTitle: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    endIcon : {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEn() {
      return this.$i18n.locale === 'en'
    }
  },
  methods: {
    useArrangementOfIcons(text, title, white, endIcon, isEn) {
      if (!text) {
        return ''
      }
      const result = text.split('<hint>')
      const arr = result.map(elem => {
        const miniArr = elem.split('=')
        return {text: miniArr[0], hint: miniArr[1]}
      })
      return arr.map(elem => {
        return {
          hint: elem.hint,
          text: arrangementOfIcons(elem.text, title, white, endIcon, isEn)
        }
      })
    }
  }
}
